// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2zFjO","buttons":"PendingPaymentAlert_buttons__2dtd8"};